import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { filter, map, switchMap } from 'rxjs/operators';
import { BlogPostLogicService } from 'src/app/logic/blog-post.service';
import { DashboardLogicService } from 'src/app/logic/dashboard.service';
import { PassDataService } from 'src/app/services/pass-data.service';

@Component({
  selector: 'app-add-blog-post',
  templateUrl: './add-blog-post.component.html',
  styleUrls: ['./add-blog-post.component.scss']
})
export class AddBlogPostComponent implements OnInit {

  _id: string = '';
  title: string = '';
  description: string = '';
  postedDate = moment().format("YYYY-MM-DD");
  postedBy = "Naresh Avasarla";
  post: string = "";
  imageUrls: string[] = [];
  private files: any = [];
  state: any = '';
  isViewImage: boolean = true;

  filesCount: number[] = [1];

  constructor(
    private blogPostLogicService: BlogPostLogicService,
    private passDataService: PassDataService,
    private dashboardLogicService: DashboardLogicService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.state = window.history.state;
    if (this.state.data) {
      if (this.state.isEdit || this.state.isView) {
        this.title = this.state.data.title;
        this.description = this.state.data.description;
        this._id = this.state.data._id;
        this.postedDate = this.state.data.postedDate;
        this.postedBy = this.state.data.postedBy;
        this.post = this.state.data.post
        this.imageUrls = this.state.data.imageUrls
      }
    }
  }

  imageFileOutput(file: any) {
    this.files.push(file.item(0))
  }

  onAddAnotherImage(file: any) {
    this.filesCount.push(this.filesCount.length + 1)
  }

  setTitle(title: string) {
    this.title = title;
  }

  setDescription(description: string) {
    this.description = description;
  }

  setPostedDate(date: string) {
    this.postedDate = date;
  }

  setPostedBy(by: string) {
    this.postedBy = by;
  }

  setPost(post: string) {
    this.post = post;
  }

  async onAddClick() {
    this.passDataService.setPopup({
      isPopup: true,
      message: '',
      isOk: false,
      isDelete: false,
      isLoading: true,
      loadingMessage: 'Adding blog post, please wait!',
    });

    if (this.files.length == null || this.title == '') {
      this.passDataService.setPopup({
        isPopup: true,
        message: 'Title and image fields are mandotary',
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
      return;
    }

    const data = await this.blogPostLogicService
      .addBlogPostLogic(
        this.title,
        this.description,
        this.postedDate,
        this.postedBy,
        this.post,
        this.files
      )

    if (data?.message == "Blog Post added succesfully") {
      this.router.navigate(['/page/blog-post-list']);
      this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe();

      this.passDataService.setPopup({
        isPopup: true,
        message: data?.message,
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
    } else {

      this.passDataService.setPopup({
        isPopup: true,
        message: 'Error while adding blog post. Please try again later.',
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
    }

  }

  onEditClick() {
    this.state.isEdit = !this.state.isEdit;
    this.state.isView = !this.state.isView;
  }

  async onUpdateClick() {
    this.passDataService.setPopup({
      isPopup: true,
      message: '',
      isOk: false,
      isDelete: false,
      isLoading: true,
      loadingMessage: 'Updating blog post info, please wait!',
    });

    if (this.title == '' || this.description == '') {
      this.passDataService.setPopup({
        isPopup: true,
        message: 'Title and description are mandatory',
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
      return;
    }

    const data = await this.blogPostLogicService
      .updateBlogPostLogic(
        this._id,
        this.title,
        this.description,
        this.postedDate,
        this.postedBy,
        this.post,
        this.files,
        this.state.data.imageUrls
      )

    if (data?.message == "Blog Post updated succesfully") {
      this.router.navigate(['/page/blog-post-list']);
      this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe();

      this.passDataService.setPopup({
        isPopup: true,
        message: data.message,
        isOk: true,
        isDelete: false,
        isLoading: false,
        loadingMessage: '',
      });
    }

  }

  onImageDelete(link: string) {

    this.passDataService.setPopup({
      isPopup: true,
      message: 'Are you sure to delete this image?',
      isOk: false,
      isDelete: true,
      response: '',
    });

    this.passDataService
      .getPopupAction()
      .pipe(
        filter((a) => a != '' || a != null || typeof a != 'undefined'),
        map((b) => b == 'delete'),
        filter((c) => c),
        switchMap(async (d) => {
          this.passDataService.setPopup({
            isPopup: true,
            message: '',
            isOk: false,
            isDelete: false,
            isLoading: true,
            loadingMessage: 'Deleting image, please wait!',
          });
          const data = await this.blogPostLogicService.deleteBlogPostImageLogic(this._id, link, this.imageUrls)
          return data;
        })
      )
      .subscribe((v: any) => {
        if (v.message == 'success') {
          this.imageUrls = v?.links;
          this.state.data.imageUrls = v?.links
          this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe();
          this.passDataService.setPopup({
            isPopup: true,
            message: 'Image deleted successfully!',
            isOk: true,
            isDelete: false,
            response: '',
          });
        } else {
          this.passDataService.setPopup({
            isPopup: true,
            message: 'Error while deleting image. pLease try again later.',
            isOk: true,
            isDelete: false,
            isLoading: false,
            loadingMessage: '',
          });
        }
      });
  }

}
